import {
  RolesApi,
  type CreateMemberRoleAssignmentRequest,
  type UpdateMemberRoleAssignmentRequest,
  type MemberRoleAssignmentResponse,
  type MemberRoleAssignmentListResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

export type {
  CreateMemberRoleAssignmentRequest,
  UpdateMemberRoleAssignmentRequest,
  MemberRoleAssignmentResponse,
  MemberRoleAssignmentListResponse
};

class WrappedMemberRolesApi {
  async list(familyId: string, familyMemberId: string): Promise<ApiResult<MemberRoleAssignmentListResponse>> {
    return withApiSetup(
      (config) => new RolesApi(config),
      getApiConfiguration,
      (api) => api.getMemberRoleAssignments(familyId, familyMemberId)
    );
  }

  async create(
    familyId: string,
    familyMemberId: string,
    request: CreateMemberRoleAssignmentRequest
  ): Promise<ApiResult<MemberRoleAssignmentResponse>> {
    return withApiSetup(
      (config) => new RolesApi(config),
      getApiConfiguration,
      (api) => api.createMemberRoleAssignment(familyId, familyMemberId, request)
    );
  }

  async update(
    familyId: string,
    familyMemberId: string,
    userId: string,
    request: UpdateMemberRoleAssignmentRequest
  ): Promise<ApiResult<MemberRoleAssignmentResponse>> {
    return withApiSetup(
      (config) => new RolesApi(config),
      getApiConfiguration,
      (api) => api.updateMemberRoleAssignment(familyId, familyMemberId, userId, request)
    );
  }

  async remove(familyId: string, familyMemberId: string, userId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new RolesApi(config),
      getApiConfiguration,
      (api) => api.deleteMemberRoleAssignment(familyId, familyMemberId, userId)
    );
  }
}

export const memberRolesApi = new WrappedMemberRolesApi();
export default memberRolesApi;
